/**
 * 数据分组
 * @param {Array} stuCount 
 * @param {Number} col 
 */
export function groupingData(stuCount, col = 4) {
  if (stuCount.length > col) {
    const arr = new Array();
    const cow = stuCount.length / col == 0 ? stuCount.length / col : Math.ceil((stuCount.length / col));
    for (let i = 1; i <= cow; i++) {
      const tempArr = [];
      let temp;
      if (col * i > stuCount.length) {
        temp = stuCount.length;
      } else {
        temp = col * i;
      }
      for (let j = col * (i - 1); j < temp; j++) {
        tempArr.push(stuCount[j]);
      }
      arr.push(tempArr);
    }
    return arr
  }
  return [stuCount]
}